<template>
  <Popover ref="popoverRef">
    <template v-for="(_, slotName) in $slots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps ?? {}" />
    </template>
  </Popover>
</template>

<script setup lang="ts">
import type { PopoverEmits, PopoverProps } from "primevue";

import { Popover } from "primevue";
import { useTemplateRef } from "vue";

defineProps</* @vue-ignore */ PopoverProps>();
defineEmits</* @vue-ignore */ PopoverEmits>();

const popoverRef = useTemplateRef<InstanceType<typeof Popover>>("popoverRef");

defineExpose({
  hide: () => popoverRef.value?.hide(),
  show: (event: Event) => popoverRef.value?.show(event),
  toggle: (event: Event) => popoverRef.value?.toggle(event),
});
</script>

<style lang="postcss">
.p-popover {
  @apply mt-[10px] rounded-md border border-surface-200 bg-surface-0 text-surface-700 shadow-[0_4px_6px_-1px_rgba(0,0,0,0.1),0_2px_4px_-2px_rgba(0,0,0,0.1)] before:pointer-events-none before:absolute before:bottom-full before:left-5 before:-ms-[10px] before:h-0 before:w-0 before:border-[10px] before:border-transparent before:border-b-surface-200 after:pointer-events-none after:absolute after:bottom-full after:left-5 after:-ms-[8px] after:h-0 after:w-0 after:border-[8px] after:border-transparent after:border-b-surface-0;

  &-content {
    @apply p-3;
  }

  &-flipped {
    @apply -mt-[10px] mb-[10px];
  }

  &.p-popover-flipped::after {
    @apply border-b-transparent border-t-surface-0;
  }

  &.p-popover-flipped::before {
    @apply border-b-transparent border-t-surface-200;
  }
}
</style>
